import { AnalyticsType } from '.';

export enum PhrasePartStyle {
  STANDARD = 'span',
  EMPHASIS = 'em',
  IMPORTANT = 'strong'
}

export interface PhrasePartTypeInterface {
  text: string;
  styles: string[];
}

export interface PhraseType {
  completeText: string;
  delimeter?: string;
  items?: PhrasePartType[];
}

export interface PhrasePartTextType extends PhrasePartTypeInterface {
  __typename?: 'FlightsPhraseTextNode';
}

export interface PhrasePartLinkType extends PhrasePartTypeInterface {
  __typename?: 'FlightsPhraseLinkNode';
  accessibility?: string;
  analytics: AnalyticsType;
  displayAnalytics?: AnalyticsType;
  link: string;
  icon?: string;
}

export type PhrasePartType = PhrasePartTextType | PhrasePartLinkType;
